import config from "./configuration";
import ConstantsList from "../common/SupplierConstants";

/* eslint-disable no-unused-vars */

// this block needed to get the login Token and Login user _id
let localData = localStorage.getItem("userData");
let userData = {};
if (localData) {
  userData = JSON.parse(localData);
}

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/* Service Function starts here */

//POST - getMenuOnUserRole
async function getMenuOnUserRole(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getMenu";
  return callPOST(api_url, param);
}

// get info from the configuration.js file
async function getConfig() {
  return config;
}

//POST - Get User Login Details using _id
async function getLoginUserData() {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getUserDetails";
  let param = { _id: userData.data._id };
  return callPOST(api_url, param);
}

// API Error Handling
async function handleResponseError(response) {
  throw new Error("HTTP error, status = " + response.status);
}

// API Error Handling
async function handleError(error) {
  console.log(error.message);
}

// Common GET Method
async function callGET(api_url) {
  return fetch(api_url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + userData.token,
    },
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      if (items.responseCode !== 401) {
        // console.log(">> GET Service Call",items);
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      console.log(">> e", error);
      handleError(error);
    });
}

// Common POST Method
async function callPOST(api_url, param) {
  // console.log(">> check URL", api_url);
  if (!param) {
    param = {};
  }
  param.timeZone = userTimezone;
  return await fetch(api_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + userData.token,
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      // console.log(">> Service Login Data",items);
      if (items.responseCode !== 401) {
        // console.log(">> POST Service Call",items);
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      handleError(error);
    });
}

// Common POST Method for Upload
async function callPOSTUpload(api_url, param) {
  // console.log(">>callPOSTUpload param ", param);
  return await fetch(api_url, {
    method: "POST",
    headers: {
      // 'Content-Type': 'multipart/form-data',
      Authorization: "Bearer " + userData.token,
    },
    body: param,
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      // console.log(">> Service Login Data",items);
      if (items.responseCode !== 401) {
        // console.log(">> POST Service Call",items);
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      handleError(error);
    });
}

// Common Post ResetPassword Method
async function callPostResetPassword(api_url, param, token) {
  // console.log(">> check URL", api_url);
  if (!param) {
    param = {};
  }
  return await fetch(api_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      // console.log(">> Service Login Data",items);
      if (items.responseCode !== 401) {
        // console.log(">> POST Service Call",items);
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      handleError(error);
    });
}

//POST - Upload files
async function uploadFiles(param) {
  let api_url = config.BASE_URL + "api/uploadFiles";
  return callPOSTUpload(api_url, param);
}
//POST - getUploadedFiles files
async function getUploadedFiles(param) {
  let api_url = config.BASE_URL + "api/getUploadedFiles";
  return callPOST(api_url, param);
}

//POST - LOGIN USER
async function login(param) {
  let api_url = config.BASE_URL + "api/login";
  return fetch(api_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      if (items.status === 200) {
        console.log(">> Service Login Data", items);
        localStorage.setItem("token", items.token);
        localStorage.setItem("application", items?.data?.defaultAppCode);
        localStorage.setItem("userData", JSON.stringify(items));
        // sessionStorage.setItem('token',items.token);
        return items;
      } else {
        return items;
      }
    })
    .catch((error) => {
      handleError(error);
    });
}

//POST - LOGOUT USER
async function logout(param) {
  let api_url = config.BASE_URL + "api/logout";
  return fetch(api_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authentication: "Bearer " + userData.token,
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      console.log(">> Service Logout", items);
      localStorage.setItem("token", "");
      localStorage.setItem("userData", "");
      localStorage.setItem("application", "");
      return items;
    })
    .catch((error) => {
      handleError(error);
    });
}

/* ---------------------------- Dashboard --------------------------------*/

//dashboard - supplier // "Yearly", "Monthly", "Custom"
async function dashboard(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/dashboard";
  return callPOST(api_url, param);
}

//Generate Chart Query
async function generateChartQuery(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/generateChartQuery";
  return callPOST(api_url, param);
}

async function addMaterial(param) {
  let api_url = config.BASE_URL + "api/addMaterial";
  return callPOST(api_url, param);
}

//Query name
async function generateCustomerQuery(param) {
  let api_url = config.BASE_URL + "customer/api/generateCustomerQuery";
  return callPOST(api_url, param);
}

//Production Order

async function addProductionOrder(param) {
  let api_url = config.BASE_URL + "inventory/api/addProductionOrder";
  return callPOST(api_url, param);
}

async function getProductionOrderDatails(param) {
  let api_url = config.BASE_URL + "inventory/api/getProductionOrderDatails";
  return callPOST(api_url, param);
}

//Ware house

async function addWarehouse(param) {
  let api_url = config.BASE_URL + "inventory/api/addWarehouse";
  return callPOST(api_url, param);
}
async function getWarehouseDatails(param) {
  let api_url = config.BASE_URL + "inventory/api/getWarehouseDatails";
  return callPOST(api_url, param);
}

async function getStockDatails(param) {
  let api_url = config.BASE_URL + "inventory/api/getStockDatails";
  return callPOST(api_url, param);
}

async function addStock(param) {
  let api_url = config.BASE_URL + "inventory/api/addStock";
  return callPOST(api_url, param);
}
async function addMatIndent(param) {
  let api_url = config.BASE_URL + "inventory/api/addMatIndent";
  return callPOST(api_url, param);
}
async function getIndentDetail(param) {
  let api_url = config.BASE_URL + "inventory/api/getIndentDetail";
  return callPOST(api_url, param);
}
async function acknowledgeIndent(param) {
  let api_url = config.BASE_URL + "inventory/api/acknowledgeIndent";
  return callPOST(api_url, param);
}
async function addPOWH(param) {
  let api_url = config.BASE_URL + "inventory/api/addPOWH";
  return callPOST(api_url, param);
}
async function getPurchaseOrderDetailWH(param) {
  let api_url = config.BASE_URL + "inventory/api/getPurchaseOrderDetailWH";
  return callPOST(api_url, param);
}
async function updatePOWH(param) {
  let api_url = config.BASE_URL + "inventory/api/updatePOWH";
  return callPOST(api_url, param);
}
async function cancelPOWH(param) {
  let api_url = config.BASE_URL + "inventory/api/cancelPOWH";
  return callPOST(api_url, param);
}
async function updateWarehouseDocument(param) {
  let api_url = config.BASE_URL + "inventory/api/updateWarehouseDocument";
  return callPOST(api_url, param);
}
async function cancelWH(param) {
  let api_url = config.BASE_URL + "inventory/api/cancelWH";
  return callPOST(api_url, param);
}
async function getModuleStats(param) {
  let api_url = config.BASE_URL + "apauto/api/getModuleStats";
  return callPOST(api_url, param);
}
async function cancelOrDeleteStock(param) {
  let api_url = config.BASE_URL + "inventory/api/cancelOrDeleteStock";
  return callPOST(api_url, param);
}
async function updateStockDocument(param) {
  let api_url = config.BASE_URL + "inventory/api/updateStockDocument";
  return callPOST(api_url, param);
}
async function cancelOrDeleteMatIndent(param) {
  let api_url = config.BASE_URL + "inventory/api/cancelOrDeleteMatIndent";
  return callPOST(api_url, param);
}
async function updateMatIndentDocument(param) {
  let api_url = config.BASE_URL + "inventory/api/updateMatIndentDocument";
  return callPOST(api_url, param);
}
async function saveDraft(param) {
  let api_url = config.BASE_URL + "inventory/api/saveDraft";
  return callPOST(api_url, param);
}
/* ---------------------------- Logistics APP --------------------------------*/
const func = {
  handleResponseError,
  handleError,
  callGET,
  callPOST,
  callPOSTUpload,
  callPostResetPassword,

  generateChartQuery,
  dashboard,
  addMaterial,
  addProductionOrder,
  generateCustomerQuery,
  getProductionOrderDatails,
  addWarehouse,
  getWarehouseDatails,

  getStockDatails,
  addStock,
  addMatIndent,
  getIndentDetail,
  acknowledgeIndent,
  addPOWH,
  getPurchaseOrderDetailWH,
  updatePOWH,
  cancelPOWH,
  updateWarehouseDocument,
  cancelWH,
  getModuleStats,
  cancelOrDeleteStock,
  updateStockDocument,
  cancelOrDeleteMatIndent,
  updateMatIndentDocument,
  saveDraft
};

export default func;
